import { useState, useEffect } from 'react'
import { useSearchParams, Link, useNavigate } from 'react-router-dom'
import apiService from '../services/api'

const AuthResetPassword = () => {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()

  // Vérifier validité du token au chargement
  const [valid, setValid] = useState(true)
  useEffect(() => {
    const check = async () => {
      if (!token) { setValid(false); setError('Lien invalide'); return }
      try {
        const res = await apiService.get(`/auth/reset-password/validate`, { params: { token }})
        if (!res.data?.valid) {
          if (res.data?.reason === 'expired') setError('Lien expiré')
          else setError('Lien invalide')
          setValid(false)
        } else {
          setValid(true)
        }
      } catch (e) {
        setValid(false)
        setError('Erreur serveur')
      }
    }
    check()
  }, [token])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setMessage('')
    if (!password || password.length < 6) {
      setError('Mot de passe trop court (min 6)')
      return
    }
    if (password !== confirm) {
      setError('Les mots de passe ne correspondent pas')
      return
    }
    setLoading(true)
    try {
      await apiService.post('/auth/reset-password', { token, password })
      setMessage('Mot de passe mis à jour. Vous pouvez vous connecter.')
      setTimeout(()=> navigate('/login'), 1500)
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de réinitialisation')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
      <div className="card w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">Réinitialiser le mot de passe</h1>
        {message && <p className="text-green-600 text-sm mb-3">{message}</p>}
        {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
        {valid ? (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Nouveau mot de passe</label>
            <input type="password" className="input-field" value={password} onChange={e=>setPassword(e.target.value)} placeholder="********" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Confirmer le mot de passe</label>
            <input type="password" className="input-field" value={confirm} onChange={e=>setConfirm(e.target.value)} placeholder="********" />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={loading || !token}>{loading ? 'Mise à jour...' : 'Mettre à jour le mot de passe'}</button>
        </form>
        ) : (
          <div className="text-center">
            <p className="text-gray-700 mb-4">{error || 'Lien invalide ou expiré.'}</p>
            <Link to="/forgot-password" className="btn-outline">Demander un nouveau lien</Link>
          </div>
        )}
        <p className="text-sm text-gray-600 mt-4 text-center">
          <Link to="/login" className="text-orange-600 hover:underline">Retour à la connexion</Link>
        </p>
      </div>
    </div>
  )
}

export default AuthResetPassword


